import { WalletStoreType } from '@wallet/account';
import WalletZustandStore from './WalletZustandStore';

export const useClearWalletStore = (): { clear: () => void } => {
  return {
    clear: WalletZustandStore((state: WalletStoreType) => state.resetStore),
  };
};
